<!-- eslint-disable max-len -->
<template>
  <div class="pt-20 p-5 w-11/12 overflow-y-scroll">
    <div class="mt-2">
      <div class="flex flex-col justify-between md:flex-row border-b border-gray-200 py-3">
        <h1 class="flex text-3xl" >Change Password</h1>
      </div>
      <div class="flex flex-col md:flex-row border-b border-gray-200">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">New Password</div>
        <div class="flex-1 flex flex-col md:flex-row">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex flex-col">
              <div class="flex-1" >
                <p v-if="$v.input.new_password.$dirty && !$v.input.new_password.required" class="text-red-500 text-xs italic text-left">New Password is required</p>
              </div>
              <div class="flex-1" >
                <input
                  type="password"
                  class="block border border-grey-light w-full p-3 rounded"
                  :class=" ($v.input.new_password.$dirty && !$v.input.new_password.required) ? 'border-red-500' : ''"
                  name="new_password"
                  placeholder="New Password"
                  v-model="input.new_password"
                  :disabled="isLoading"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row border-b border-gray-200">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Confirm New Password</div>
        <div class="flex-1 flex flex-col md:flex-row">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex flex-col">
              <div class="flex-1" >
                <p v-if="$v.input.confirm_new_password.$dirty && !$v.input.confirm_new_password.sameAsPassword" class="text-red-500 text-xs italic text-left">Confirm New Password not match</p>
              </div>
              <div class="flex-1" >
                <input
                  type="password"
                  class="block border border-grey-light w-full p-3 rounded"
                  :class=" ($v.input.confirm_new_password.$dirty && !$v.input.confirm_new_password.sameAsPassword) ? 'border-red-500' : ''"
                  name="confirm_new_password"
                  placeholder="Confirm New Password"
                  v-model="input.confirm_new_password"
                  :disabled="isLoading"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col md:flex-row ">
        <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">
          <button @click="changePassword" :disabled="isLoading" class="text-sm  mx-2 w-64  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer
                          bg-teal-700 text-teal-100
                          hover:bg-teal-100
                          hover:text-teal-700
                            border duration-200 ease-in-out
                          border-teal-600 transition">
            <!-- eslint-disable max-len -->
            Update Password
            <!-- eslint-enable max-len -->
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  name: 'ChangePasswordUser',
  mixins: [validationMixin],
  data: () => ({
    input: {
      new_password: '',
      confirm_new_password: '',
    }
  }),
  validations: {
    input: {
      new_password: {
        required,
      },
      confirm_new_password: {
        sameAsPassword:sameAs('new_password'),
      },
    }
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser']),
  },
  methods: {
    ...mapActions('UserModule', ['requestChangePasswordUser']),
    async changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // const profile = this.$refs.editProfile.input;
        const result = await this.requestChangePasswordUser({
          id: this.getUser.id,
          password: this.input.new_password,
        });
        this.$v.$reset();
        this.input.new_password = '';
        this.input.confirm_new_password = '';
        this.$swal('Update', 'You successfully update the password', 'success')
      }
    },
  },
  components: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ChangePasswordUser.vue